import axios from 'axios';
import { config } from './environment';

export const backendUrl = config.apiBaseUrl;
export const uploadsUrl = config.apiBaseUrl.replace('/api/v2', '') + '/uploads';

if (config.isDevelopment) {
	console.log('🔗 Admin API Base URL:', backendUrl);
	console.log('🌍 Environment:', process.env.NODE_ENV);
	console.log('🎯 App Environment:', config.environment);
}

const api = axios.create({
	baseURL: backendUrl,
	headers: {
		'Content-Type': 'application/json',
	},
});

api.interceptors.request.use(
	(config) => {
		const user = JSON.parse(localStorage.getItem('user') || 'null');
		const token = user?.token;

		if (token) {
			config.headers['Authorization'] = `Bearer ${token}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	},
);

api.interceptors.response.use(
	(response) => response,
	(error) => {
		// Let individual components handle their own errors
		// Don't automatically redirect here - this causes conflicts
		if (error.response && error.response.status === 401) {
			console.error('Unauthorized request detected');
		} else if (!error.response) {
			console.error('Network error detected');
		}
		return Promise.reject(error);
	},
);

export default api;
